import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl } from 'src/globals';
import { getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { booking_returndata } from 'src/types/booking_returndata';
import { BusyService } from '../_services/busy.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { MenuItem } from 'primeng/api/menuitem';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { cBookingfee } from 'src/types/bookingfee';
import { bookingfee_returndata } from 'src/types/bookingfee_returndata';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;
  PreviousBookingDate: Date;
  hubConnection: HubConnection;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  PreviousHubs: string[] = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  searchCriteria: string = "";
  //PageLinks: any;
  //currentPageIndex: number = 4;

  cols: any[];

  //@ViewChild('resourceTable') dataTable: any;
  //@ViewChild('table', { static: true }) dataTable!: any;

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get useMobileView(): boolean {
    if (this.screenwidth <= 1024) return true;
    return this.screenwidth <= 1200 && this.screenheight > this.screenwidth;
  }
  selectedAction: any = null;

  constructor(
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService,
    private route: ActivatedRoute) {
      
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("HOME", user)){
          this.AccessAllowed = true;
        }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }

  getSearchResults(){
    if(this.searchCriteria != "")
    {
      localStorage.removeItem("SearchResults");
      let crit = this.searchCriteria;

      crit = crit.trim();

      crit = crit.replace("/","-").replace("/","-");
      crit = encodeURIComponent(crit);

      this.searchCriteria = "";
      this.router.navigate(
        ['/search'],
        { queryParams: { crit: crit } }
      );
    }
  }

  acknowledge(BID)
  {
    this.http.get(bmxurl + "acknowledge/" + this.VenueID + "/" + BID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Acknowledged', detail:'Booking successfully acknowledged'});
        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Acknowledged', detail: 'An error occurred acknowledging this Booking'});
    })
  }
  
  ngOnDestroy() {
    //this.hubConnection.stop();
  }

  showInProgress(){
    this.inProgress = true;
    this.loadgrid(false);
  }

  unshowInProgress(){ 
    this.inProgress = false;
    this.loadgrid(false);
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    this.BookingDate = new Date();

    if(this.route.snapshot.paramMap.get('startdate') != null && this.route.snapshot.paramMap.get('startdate') != 'null')
    {
      this.BookingDate = new Date(this.route.snapshot.paramMap.get('startdate'));
    }

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
    //   this.hubConnection = new HubConnectionBuilder()
	  //   .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
		//   accessTokenFactory: () => tokenReturned 
	  // }).build();

    let menuItems: MenuItem[];

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse = (response as any)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        let Home = localStorage.getItem("ChosenHomePage") == null ? "/home" : "/" + localStorage.getItem("ChosenHomePage")!;

        if(this.router.url != "/pinpad" && this.router.url != "/" && this.router.url != "/business")
        {
          menuItems =
              [
              {label: 'Home', icon: 'pi pi-home', routerLink: [Home]},
              {label: 'Make A Booking', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
              {label: 'Quick Book', icon: 'pi pi-telegram', routerLink: ['/booking/0/true']},
              {
                label: 'Sell',
                items: [
                  {label: 'Bookings', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
                  {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                  {label: 'Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                  {label: 'Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                  {label: 'Quick Book', icon: 'pi pi-telegram', routerLink: ['/booking/0/true']},
                  {label: 'Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},        
                  {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till'], visible: localStorage.getItem('TillAccess') === 'true'},
                ],
              },
              {
                label: 'Views',
                items: [
                  {label: 'At a Glance', icon: 'pi pi-eye', routerLink: ['/ataglance']},  
                  {label: 'Bookings Created Today', icon: 'pi pi-check-circle', routerLink: ['/home']},
                  {label: 'Bookings List', icon: 'pi pi-align-justify', routerLink: ['/bookinglist']},
                  {label: 'Party List', icon: 'pi pi-align-justify', routerLink: ['/partylist']},
                  {label: 'Daysheet', icon: 'pi pi-align-left', routerLink: ['/daysheetstyle1']}, 
                ],
              },
              {
                label: 'Booking Questions',
                items: [
                    
                    {label: 'Booking Questions', icon: 'pi pi-question-circle', routerLink: ['/bookingquestions']},
                    {label: 'Booking Questionnaires', icon: 'pi pi-list', routerLink: ['/bookingquestionnaire']},
                ]
              },
              {
                label: 'Emails & Confirmations',
                items: [
                    {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                    {label: 'Email Templates', icon: 'pi pi-envelope', routerLink: ['/emailtemplates']},
                ]
              },
              {
                label: 'Event Settings',
                items: [
                  {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                  {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                  {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                  {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                  {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                  {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                ]
              },
              {
                label: 'Financial',
                items: [
                    {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                    {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                ]
              },
              {
                label: 'Gift Vouchers',
                items: [
                    {label: 'Sell Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                    {label: 'Manage Gift Vouchers', icon: 'pi pi-shopping-bag', routerLink: ['/voucherlist']}, 
                ]
              },
              {
                label: 'Memberships',
                items: [
                  {label: 'Sell Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                  {label: 'Manage Memberships', icon: 'pi pi-users', routerLink: ['/membershiplist']},
                  {label: 'Membership Set-up', icon: 'pi pi-users', routerLink: ['/memberships']},
                ],
              },
              {
                label: 'Package Settings',
                items: [
                  //{label: 'Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/admissionbasedupgrades']},
                  {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                  {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                  {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                  {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                  {label: 'Extras', icon: 'pi pi-star', routerLink: ['/extra']},
                  {label: 'Multi Package Extras', icon: 'pi pi-clone', routerLink: ['/multipackageextras']},
                  {label: 'Package', icon: 'pi pi-box', routerLink: ['/package']},
                  //{label: 'Package Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/packageaddons'], visible:  true},
                  {label: 'Package Groups', icon: 'pi pi-clone', routerLink: ['/packagegroups']},
                  {label: 'Package Rules', icon: 'pi pi-tag', routerLink: ['/packagerule']},
                  {label: 'Upgrades', icon: 'pi pi-arrow-up', routerLink: ['/upgrades']},
                  {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                  {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},

                ],
              },
              {
                label: 'Resources',
                items: [
                  {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                  {label: 'Resources', icon: 'pi pi-clone', routerLink: ['/resource']},
                  {label: 'Closings and Adjustments', icon: 'pi pi-ban', routerLink: ['/resourceclosings']},
                  {label: 'Resource Groups', icon: 'pi pi-sitemap', routerLink: ['/resourcegroupnames']},
                ],
              },
              {
                label: 'Scheduled Sessions',
                items: [
                  {label: 'Sell Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},
                  {label: 'Manage Sessions', icon: 'pi pi-calendar', routerLink: ['/scheduledsessionlist']},
                  {label: 'Session Calendar', icon: 'pi pi-calendar', routerLink: ['/scheduledsessioncalendar']},
                  {label: 'Set-up Sessions', icon: 'pi pi-users', routerLink: ['/scheduledsessions']},
                ],
              },
              {
                label: 'Tasks',
                items: [
                  {label: 'Task Types', icon: 'pi pi-paperclip', routerLink: ['/tasktypelist']},
                  {label: 'Task Status List', icon: 'pi pi-list', routerLink: ['/testtask']},
                ],
              },
              {
                label: 'Till',
                visible: localStorage.getItem('TillAccess') === 'true',
                items: [
                  {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till']},
                  {label: 'Transaction Manager', icon: 'icon-pound', routerLink: ['/tillsalemanager']},
                  {label: 'Till Departments', icon: 'pi pi-table', routerLink: ['/tilldepartments']},
                  {label: 'Product Options', icon: 'pi pi-list', routerLink: ['/tillproductoptions']},
                ],
              },
              {
                label: 'Venue Management',
                items: [
                    {label: 'Booking Fees', icon: 'pi pi-money-bill', routerLink: ['/bookingfee']},
                    {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                    {label: 'Customer Portal', icon: 'pi pi-id-card', routerLink: ['/customerportal']},
                    {label: 'Discounts', icon: 'pi pi-arrow-circle-down', routerLink: ['/discounts'], visible:  true},
                    {label: 'Integrations', icon: 'pi pi-th-large', routerLink: ['/integrations'], visible: true},
                    {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                    {label: 'Link Manager', icon: 'pi pi-link', routerLink: ['/linkmanager']},
                    {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                    {label: 'Terms & Conditions', icon: 'pi pi-check-square', routerLink: ['/terms']},
                    {label: 'Time Sets', icon: 'pi pi-clock', routerLink: ['/timesets']},
                    {label: 'User Management', icon: 'pi pi-user', routerLink: ['/users']},
                    {label: 'Venue Closings', icon: 'pi pi-lock', routerLink: ['/venueclosings']},
                    {label: 'Venue Settings', icon: 'pi pi-cog', routerLink: ['/venuesettings']},
                    {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                ]
              },
              {
                label: 'Waivers',
                items: [
                    {label: 'Manage Statement of Risk', icon: 'pi pi-file', routerLink: ['/statementofrisk']},
                    //{label: 'Manage Waivers', icon: 'pi pi-file', routerLink: ['/managewaivers']},
                ]
              },
              {label: 'Dashboard (BETA)', icon: 'pi pi-lock', routerLink: ['/altfrontpage']},

              //{label: 'Agreement', icon: 'pi pi-lock', routerLink: ['/agreement/301c162e-0901-4732-b952-afe29c0a9902']}
            
            
          ];
        
          this.globalService.setMenuItems(menuItems);  

          this.globalService.setBCItem(['Home','/home']);
        }

        let UseCounters = localStorage.getItem("UseCounter")
        this.globalService.setUseCounters(UseCounters);
    
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get User' });
    });

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    this.PreviousHubs.push(BookingEventDate);

    // this.hubConnection.start();

    // this.hubConnection.off(BookingEventDate);

    // this.hubConnection.on(BookingEventDate, data => {
    //    this.loadgrid(false);
    // });

    //this.busyService.busy();

        //Get Settings and put them in Local Storage
        this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
          this.httpResponse =  (response as venuesettings_returndata)
          if(this.httpResponse.succeeded)
          {
            //Set Venue Settings ID
            localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
    
            this.httpResponse.data.venueSettings.forEach(element => {
              localStorage.setItem(element.name, element.value);
            });

            if(localStorage.getItem("VoucherEmailTemplate") == null || localStorage.getItem("VoucherEmailTemplate") == "null")
            {
              localStorage.setItem("VoucherEmailTemplate", "");
            }
            {

            }

            this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
            this.loadgrid(false);
          }
          else{
            //this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
        });

    });

    // this.http.get(bmxurl + "bookingfee/" + this.VenueID).subscribe(response => {
    //   this.httpResponse = (response as bookingfee_returndata)
    //   if (this.httpResponse.succeeded)
    //   {
    //     if(this.httpResponse.data != null)
    //     {
    //       let BookingFee: cBookingfee = {
    //         id: (this.httpResponse.data as cBookingfee).id,
    //         venueid: (this.httpResponse.data as cBookingfee).venueid,
    //         disabled: (this.httpResponse.data as cBookingfee).disabled,
    //         bfid: (this.httpResponse.data as cBookingfee).bfid,
    //         name: (this.httpResponse.data as cBookingfee).name,
    //         isdefault: (this.httpResponse.data as cBookingfee).isdefault,
    //         bfpublicapply: (this.httpResponse.data as cBookingfee).bfpublicapply,
    //         bfadminapply: (this.httpResponse.data as cBookingfee).bfadminapply,
    //         bfpublicshowtext: (this.httpResponse.data as cBookingfee).bfpublicshowtext,
    //         bfpublictext: (this.httpResponse.data as cBookingfee).bfpublictext,
    //         bfpublictype: (this.httpResponse.data as cBookingfee).bfpublictype,
    //         bfadmintype: (this.httpResponse.data as cBookingfee).bfadmintype,
    //         bfpublicfee: (this.httpResponse.data as cBookingfee).bfpublicfee,
    //         bfpublicmin: (this.httpResponse.data as cBookingfee).bfpublicmin,
    //         bfpublicmax: (this.httpResponse.data as cBookingfee).bfpublicmax,
    //         bfadminfee: (this.httpResponse.data as cBookingfee).bfadminfee,
    //         bfadminmin: (this.httpResponse.data as cBookingfee).bfadminmin,
    //         bfadminmax: (this.httpResponse.data as cBookingfee).bfadminmax,
    //         bookingfeeappliestomemberspublic: (this.httpResponse.data as cBookingfee).bookingfeeappliestomemberspublic,
    //         bookingfeeappliedonmembershippurchasespublic: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasespublic,
    //         bookingfeeappliestomembersadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliestomembersadmin,
    //         bookingfeeappliedonmembershippurchasesadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasesadmin,
    //       };

    //       localStorage.setItem("VenueBookingFee", JSON.stringify(BookingFee));
    //     }
    //   }
    //   else
    //   {
    //     this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee'});
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee, error:' + error.messages[0]});
    // });


    this.cols = [
      { field: 'bookingIdHR', header: 'Sales ID' },
      { field: 'creatddateCSV', header: 'Created Date' },
      { field: 'startTimeCSV', header: 'Start Date/Time' },
      { field: 'name', header: 'Name' },
      { field: 'email', header: 'Email' },
      { field: 'phone', header: 'Phone' },
      { field: 'packageName', header: 'Package' },
      { field: 'resourcestring', header: 'Resource' },
      { field: 'guests', header: 'Guests' },
      { field: 'admissions', header: 'Admissions' },
      { field: 'total', header: 'Total' },
      { field: 'outstanding', header: 'Outstanding' },
      { field: 'extraslist', header: 'Extras' },
      { field: 'allergy', header: 'Allergy' },
      { field: 'notes', header: 'Notes' },
      ];
  }

  editdata(ID){

    localStorage.addItem("homeScreenBookings", JSON.stringify(this.ListBookings));
    localStorage.addItem("listScreen", "FALSE");
    localStorage.addItem("homeitem", "FALSE");
    localStorage.addItem("homeScreenNumberOfRecords", 0);
    localStorage.addItem("homeScreenCurrentPage", );

    this.router.navigateByUrl("/editbooking/" + ID);
  }

  editdatanew(ID){
    this.router.navigateByUrl("/editbooking/" + ID + "/" + this.BookingDate.toISOString().substring(0,10));
  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(BookingID)
  {
    if (confirm("Are you sure you want to disable this booking?"))
     {
        this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + BookingID).subscribe(response => {
          this.CreateUpdateResponse = response
          if(this.CreateUpdateResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Disabled', detail:'Booking successfully disabled'});
            this.loadgrid(false);
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Booking'});
        })
      }
  }

  emailConf(BookingID)
  {
    this.http.get<any>(bmxurl + "confirmationemail/" + this.VenueID + "/" + BookingID).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Sent Booking Confirmation.'})
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not send Booking Confirmation: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send Booking Confirmation'});
    })
  }

  undisableData(BookingID)
  {
    this.http.get(bmxurl + "enablebooking/" + this.VenueID + "/" + BookingID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Enabled', detail:'Booking successfully enabled'});
        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred enabling this Booking'});
    })
  }

  abandonBooking(BookingID)
  {
    let abandonBooking: any = {
      bookingid: BookingID,
      jwt: null
    }
    //Booking Exists, abandon it
    this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
      this.messageService.add({severity:'success', summary:'Abandoned', detail:'Booking abandoned successfully.'});
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
    });
  }

  loadgrid(showdisabled: boolean)
  {
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;
    
    //this.busyService.busy();
    this.http.get(bmxurl + "BookingCreatedMin/" + this.VenueID + "/" + dateChosen + "/" + showdisabled).subscribe(response => {
      try{
        this.CreateUpdateResponse = (response as booking_returndata);

        //Get VenueDate
        this.ListBookingsGlobal = this.CreateUpdateResponse.data;

        var thisYear: any = this.BookingDate.getFullYear();
        var thisMonth: any = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
        var thisDay: any = ('00' + this.BookingDate.getDate()).slice(-2);
        var fullDate: any = thisYear + thisMonth + thisDay;

        let venueDate: string =  this.VenueID + "_" + fullDate;

        if(this.inProgress)
        {
          this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.inProgress == true);

          this.ListBookings.forEach(element => {

            let extraslist: string = "";

            // Format startTime to ISO 8601
            if(element.startTime) {
              element.startTime = new Date(element.startTime).toISOString();
              element.startTimeCSV = this.formatDateForExcel(element.startTime);
            }
            element.creatddateCSV = this.formatDateForExcel(element.createddate);

                let timeout = element.bookingtimeout;

                if(element.publicBooking == true)
                {
                  let expSecs = timeout - (new Date().getTime() - new Date(element.createddate).getTime()) / 1000;

                  if(expSecs < 0)
                  {
                    expSecs = 0;
                  }

                  element.expiry = new Date(0,0,0,0,0,expSecs);
                }
                else
                {
                  if(element.awaitingpayment == true)
                  {                
                    let expSecs = 14000 - (new Date().getTime() - new Date(element.createddate).getTime()) / 1000;

                    if(expSecs < 0)
                    {
                      expSecs = 0;
                    }

                    element.expiry = new Date(0,0,0,0,0,expSecs);
                  }
                  else
                  {
                    let expSecs = timeout - (new Date().getTime() - new Date(element.createddate).getTime()) / 1000;

                    if(expSecs < 0)
                    {
                      expSecs = 0;
                    }
  
                    element.expiry = new Date(0,0,0,0,0,expSecs);
                  }
                }
                
                if(element.extras != null)
                  {
                    if(element.extras.length > 0)
                    { 
                      element.extras.forEach(extra => {
                        extraslist += extra.name + " (" + extra.qty + "), ";
                      });
                    }

                    if(extraslist.length > 2)
                      element.extraslist = extraslist.substring(0, extraslist.length - 2);
                  }
          });
        }
        else
        {
          this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.inProgress == false);
          this.ListBookings.forEach(element => {

            let extraslist: string = "";

            // Format startTime to ISO 8601
            if(element.startTime) {
              element.startTime = new Date(element.startTime).toISOString();
              element.startTimeCSV = this.formatDateForExcel(element.startTime);
            }
            element.creatddateCSV = this.formatDateForExcel(element.createddate);

            if(element.extras != null)
              {
                if(element.extras.length > 0)
                { 
                  element.extras.forEach(extra => {
                    if (extra.qty > 0)
                      extraslist += extra.name + " (" + extra.qty + "), ";
                  });
                }

                if(extraslist.length > 2)
                  element.extraslist = extraslist.substring(0, extraslist.length - 2);
              }
          });
          
        }

        this.bookingsInProgress = this.ListBookingsGlobal.filter(obj => obj.inProgress == true).length;
        this.totalBookingsToday = this.ListBookingsGlobal.filter(obj => obj.inProgress == false).length;;

        //this.setCurrentPage(2);
      }
      catch (error){
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  maskMobile(MobileIn)
  {
    //only show last 4 digits
    if(MobileIn != null && MobileIn.length > 4)
    {
      let last4 = MobileIn.slice(-4);
      let masked = "**** **** " + last4;
      return masked;
    }
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + element.bookingId).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      }
    }, error => {

    })
    });

  }

  doneDate(){

    this.inProgress = false;

    this.loadgrid(false)

    // this.PreviousHubs.forEach(element => {
    //   this.hubConnection.off(element);
    // });

    this.PreviousHubs = [];

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    this.PreviousHubs.push(BookingEventDate);

    // this.hubConnection.on(BookingEventDate, data => {
    //   this.loadgrid(false);
    // });

  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();
  }

  exportData()
  {


  }

  customSort(event: any) {
    event.data.sort((a: any, b: any) => {
      let result = 0;

      if (event.field === 'resourcestring') {
        const res1 = a.resourcestring ?? '';
        const res2 = b.resourcestring ?? '';
        result = res1.localeCompare(res2);
        if (result === 0) {
          const d1 = new Date(a.startTime).getTime();
          const d2 = new Date(b.startTime).getTime();
          result = d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
        }
      } else {
        const val1 = a[event.field];
        const val2 = b[event.field];
        if (val1 == null && val2 != null) result = -1;
        else if (val1 != null && val2 == null) result = 1;
        else if (val1 == null && val2 == null) result = 0;
        else if (typeof val1 === 'string' && typeof val2 === 'string') result = val1.localeCompare(val2);
        else result = val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

}